import { PermitLimit } from "../types";

// Non-blocking sanity check on a typed lab result — catches the classic data-entry
// blunders (unit/decimal slips, negatives, impossible pH) before they're certified.
// Returns a gentle warning string, or null when the value looks fine. A genuine
// exceedance is NOT a sanity problem, so the magnitude check only fires at ~100x
// the limit (a µg/L↔mg/L mixup is 1000x) to avoid false alarms on real violations.
export function sampleSanityWarning(limit: PermitLimit, val: number | null): string | null {
  if (val === null || isNaN(val)) return null;
  if (val < 0) return "Negative value — please double-check this entry.";
  if (limit.is_monitor_report) return null;
  if (limit.is_range_limit) {
    const unit = (limit.range_unit ?? "").toLowerCase();
    const looksPh = unit.includes("s.u") || unit.includes("su") || unit.includes("ph");
    if (looksPh && val > 14) return "Outside the possible pH range (0–14) — check the entry.";
    return null;
  }
  const ref = limit.daily_max_concentration ?? limit.weekly_max_concentration ?? limit.monthly_avg_concentration ?? null;
  if (ref != null && ref > 0 && val >= ref * 100) {
    const x = Math.round(val / ref);
    return `Unusually high — about ${x}× the limit. Check units (µg/L vs mg/L) or a misplaced decimal.`;
  }
  return null;
}
